import { render } from "./TheAddConsumer.vue?vue&type=template&id=f65c9ba6&scoped=true&ts=true"
import script from "./TheAddConsumer.vue?vue&type=script&lang=ts"
export * from "./TheAddConsumer.vue?vue&type=script&lang=ts"

import "./TheAddConsumer.vue?vue&type=style&index=0&id=f65c9ba6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f65c9ba6"]])

export default __exports__